import { mapMinimalOrderToCardData } from 'features/menu/pages/recent-items-page/minimal-recent-items/utils';

import {
  IConfigOfferEntryDto,
  IRewardEntryDto,
  ISystemWideOfferEntryDto,
  IUserMinimalOrderFragment,
} from 'generated/graphql-gateway';
import { ILocalizedMenuEntry, IndexedMenu } from 'state/unified-menu/types';

import { MinimalAccountOrder } from './types';

type MinimalSelectionNode = {
  id: string;
  menuSelections?: ReadonlyArray<MinimalSelectionNode> | null;
};

const hasLoyaltySelection = (
  entries: ReadonlyArray<MinimalSelectionNode> | null | undefined,
  indexedOffers: IndexedMenu<IConfigOfferEntryDto | ISystemWideOfferEntryDto>,
  indexedRewards: IndexedMenu<IRewardEntryDto>
): boolean => {
  if (!entries?.length) {
    return false;
  }

  return entries.some(entry => {
    if (indexedOffers.find(entry.id) || indexedRewards.find(entry.id)) {
      return true;
    }

    return hasLoyaltySelection(entry.menuSelections, indexedOffers, indexedRewards);
  });
};

export const mapMinimalOrderToAccountOrder = ({
  order,
  menu,
  indexedOffers,
  indexedRewards,
  posServiceMode,
}: {
  order: IUserMinimalOrderFragment;
  menu: IndexedMenu<ILocalizedMenuEntry>;
  indexedOffers: IndexedMenu<IConfigOfferEntryDto | ISystemWideOfferEntryDto>;
  indexedRewards: IndexedMenu<IRewardEntryDto>;
  posServiceMode: 'delivery' | 'pickup';
}): MinimalAccountOrder => {
  const mapped = mapMinimalOrderToCardData({
    order,
    menu,
    indexedOffers,
    indexedRewards,
    posServiceMode,
  });

  return {
    ...order,
    ...mapped,
    hasLoyaltySelection: hasLoyaltySelection(
      order.cart.menuSelections as ReadonlyArray<MinimalSelectionNode>,
      indexedOffers,
      indexedRewards
    ),
  };
};
